<template>
  <div
    v-if="show"
    class="raise_box_warpper"
    @click.self="handleClickClose"
    :style="styleVar"
  >
    <div class="raise-box-content" >
      <div class="content-bg">
        <img v-if="!imgFlag" :src="contentBg">
        <img v-else  :src="contentImg">
      </div>
      <div class="main-content">
        <div class="main-img">
          <p class="openTitle" ref="openTitleVip">
            <img src="https://qncweb-back1.ktvsky.com/20211027/vadd/8da9f9ca6b106d54e1576922cef3f008.png">
            <span>会员开通成功</span>
          </p>
        </div>
        <div v-if="imgFlag" class="content-btn">
          <div class="btn">
            <div class="payVipButton" @click="payVipButton"></div>
            <div v-if="isToping" class="btn-gohome" @click="handleClickHome"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="close">
      <img @click="handleClickClose" src="../adsense/static/close.png">
    </div>
  </div>
</template>

<script>
import mixinOldVip from '@/mixins/vip-toast-test';
import { reportPay } from '@/libs/utils/log/log';
import { utils } from '@/libs/interfaces';
import store from '@/store';

const TOUCH_ORDER_CONFIG = {
  'touch_order_vip': {
    name: '立即置顶',
    desc: '触摸屏已点落地页',
  },
  'touch_order_vip_cc': {
    name: '点击查看常唱',
    desc: '触屏已点-常唱',
  },
  'touch_order_vip_gs': {
    name: '点击歌神点歌',
    desc: '触屏已点歌神',
  },
}

export default {
  name: 'RaiseAnimationPayment',
  mixins: [mixinOldVip],
  data() {
    return {
      show: false,
      page_tp: 'vip_openyear',
      starName: '',
      enterTime: 0,
      propStyleVar: {},
      imgFlag: false,
      contentBg: 'https://qncweb-back1.ktvsky.com/20211027/vadd/b4fb073e8ae75282f59ea37c7dcbce5a.png',
      contentImg: 'https://qncweb-back1.ktvsky.com/20220614/vadd/e993f9966bae7e7a6a21ec5bbb79df1b.png',
      memberId: 81, // 1年9.9元
      pay_fee: 990,
      isToping: false,
    }
  },
  computed: {
    styleVar() {
      return {
        '--text-color': this.propStyleVar.textColor || '#FDDD98', // 文案颜色
        '--mainImg-height': this.propStyleVar.mainImgHeight || '92vw', // 文案距离上边的距离
        '--payVipButton-height': this.propStyleVar.payVipButtonHeight || '35vw', // 按钮的高度
      }
    },
  },
  methods: {
    handleClickClose() {
      this.show = false;
      this.imgFlag = true;
      store.commit('SET_ORDER_LIST', true);
    },
    handlePageUnload() {
      reportPay({
        page_tp: this.page_tp,
        active_tp: 1, // 用户行为：0：点击 ;1：停留
        stay_time: Date.now() - this.enterTime, // 停留时间(单位：毫秒)
      });
    },
    handleClickHome() {
      // FromType===touch_order_vip和touch_order_vip_cc 都需要置顶
      const touchOrder = TOUCH_ORDER_CONFIG[this.event.$route.query.FromType]
      if (touchOrder) {
        this.$sendLog({
          event_type: 'click',
          event_name: `开通1个月-${touchOrder.name}`,
          event_data: {
            desc: touchOrder.desc,
          },
        });
      }
      this.show = false;
      this.event.$router.push('/thunder/home');
    },
    payVipButton() {
      reportPay({
        page_tp: this.page_tp,
        active_tp: 0, // 用户行为：0：点击 ;1：停留
        source: 0,
      });
      this.imgFlag = true;
      store.commit('SET_ORDER_LIST', true)
      utils.util.buyVipPlus({
        memberId: this.memberId,
        pay_fee: this.pay_fee,
        pay_enter: this.page_tp,
        $this: this.event,
        callback: () => {
          this.show = false;
          this.event.$store.dispatch('getIsVip');
        // 新三档支付成功弹窗在util里处理
        //   this.$RaiseMessage.close(true);
          this.event.$store.commit('SAVE_HOME_TOAST', false);
        //   this.event.$store.commit('SET_VIP_PACKAGES_TOAST');
          this.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20211027/vadd/e17d4672c4b60aa1679e5905861be978.png', '', {
            callback: () => {
              this.event.$router.push('/thunder/customer');
            },
            closeImg: require('@/views/vip/static/plus/vip_close.png'),
          });
        },
      });
    },
    getDom() {
      this.imgFlag = true;
    },
  },
  mounted() {
    if (!store.state.intervalShowOrderList) {
      store.commit('SET_ORDER_LIST', false);
    }
    this.enterTime = Date.now();
    reportPay({
      page_tp: this.page_tp,
      active_tp: 3, // 用户行为：0：点击 ;1：停留
    });
    window.addEventListener('animationend', this.getDom);
    window.addEventListener('beforeunload', this.handlePageUnload);
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handlePageUnload);
    window.addEventListener('animationend', this.getDom);
  },
}
</script>

<style lang='scss' scoped>
.raise_box_warpper {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
}
.raise-box-content {
  width: 610px;
  position: relative;
  .content-bg {
    width: 610px;
    height: auto;
  }
  .main-content {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 2;
    text-align: center;
  }
}
.main-img {
  color: var(--text-color);
  height: var(--mainImg-height);
  img {
    width: 28px;
    height: 28px;
  }
  span {
    margin-left: 10px;
  }
  .openTitle {
    animation: bounce-in 1.5s;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.content-btn {
  position: relative;
  .btn {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    .payVipButton {
      height: var(--payVipButton-height);
    }
    .btn-gohome {
      height: 19vw;
    }
    img {
      margin-bottom: 20px;
    }
  }
}
@keyframes bounce-in {
  0% {
    transform: translateY(300px) scale(0);
  }
  60% {
    transform: translateY(300px) scale(2);
  }
  100% {
    transform: translateY(0);
  }
}
.close {
  width: 54px;
  position: absolute;
  right: -20px;
  top: -74px;
}
</style>
